<template>
  <MainmenuBar />
</template>

<script>
// @ is an alias to /src
import MainmenuBar from '@/components/MainmenuBar.vue'

export default {
  name: 'DashboardView',
  components: {
    MainmenuBar
  },
  mounted() {
    setTimeout(()=>{
      const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
      e.onfinish = ()=>{
        document.querySelector('#purpleheader').style.height = "130px";
      };
    },0);
  }
}
</script>
